"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logDefinition = void 0;
const firestore_1 = require("comodel/firestore");
exports.logDefinition = (0, firestore_1.defineCollection)({
    collectionName: "log",
    idKey: "logId",
    constraints: ["projectId"],
    queryDefs: {
        list: ({ projectId, segmentId, scriptId, condition, }) => {
            return {
                constraint: { projectId },
                filterParams: Object.assign(Object.assign({}, condition), { segmentId, scriptId }),
                queryParams: {
                    orderBy: [["createdAt", "desc"]],
                },
            };
        },
    },
    defaultValue: {},
    onGenerate: (o) => (Object.assign(Object.assign({}, o), { createdAt: Date.now() })),
    onWrite: (o) => (Object.assign(Object.assign({}, o), { updatedAt: Date.now() })),
});
